import 'bootstrap';
import 'owl.carousel';
import {owlInitialize} from "./heplers";
import Cookies from 'js-cookie';

$(document).ready(function(){

    $('[data-toggle="slide-collapse"]').on('click', function(){
        const target = $(this).data('target');
        $(target).toggleClass('collapse');
    });

    window.addEventListener('click', function(e){
        const navbar = document.getElementById('navbarToggler');
        const toggleIcon = document.querySelector('.fa-bars');
        if( toggleIcon ===  e.target ) return;
        if (navbar !== e.target && navbar.classList.contains('collapse')){
            document.getElementById('navbarToggler').classList.remove('collapse');
        }
    });

    // news slider

    if( document.querySelector( '#news' ) ) {
        owlInitialize('#news', {
            items: 3,
            loop: false,
            responsive: {
                0: {
                    items: 1,
                    margin: 10
                },
                768: {
                    items: 2,
                    margin: 20
                },
                991: {
                    items: 3,
                    margin: 20
                }
            }
        });
    }

    if( document.querySelector( '.partner-list' ) ) {
        owlInitialize('.partner-list', {
            items: 8,
            responsive: {
                0: {
                    items: 3
                },
                768:{
                    items: 8,
                    autoplay: true,
                }
            }
        });
    }

    $('.insider-menu').click(function (e){
        e.stopPropagation()
    })

    var whiteHeader = document.body.classList.contains('white-header');
    window.addEventListener('scroll', function(){
        if ( ! whiteHeader ) {
            return false;
        }

        if ( window.scrollY == 0 ) {
            document.body.classList.add('white-header');
        } else {
            if ( document.body.classList.contains('white-header') ) {
                document.body.classList.remove('white-header');
            }
        }
    });

    $('li.tag-item').click(function (){
        $('.tag-item').removeClass('active');
        $(this).addClass('active');

        $.ajax({
            type: "POST",
            dataType: 'JSON',
            url: '/getBusiness',
            data: {
                '_token': $('[name=_token]').val(),
                'tagId': $(this).data('tagid'),
                'cityId': $(this).data('cityid') ?? null
            },
            success: function(data) {
                $('.index__featured .locations').html(data.html);
                $('.index__featured .locations .view-more').click(function (){
                    if($(this).find('> span').data('city') && $(this).find('> span').data('tag')) {
                        window.location = '/'+$(this).find('> span').data('city')+'/restaurante/'+$(this).find('> span').data('tag');
                        e.preventDefault()
                    }
                    $(this).siblings('.d-none').removeClass('d-none')
                    $(this).addClass('d-none')
                })
            }
        });
    })

    $('.more-tags').click(function(){
        $('li.tag-item.hidden').removeClass('hidden')
        $(this).hide()
    })

    $('.top-slider input').on('keyup',function (){
        if ($(this).val().length) {
            $(this).siblings('.input-group-append').addClass('hide').removeClass('show')
            $(this).siblings('.search-btn').addClass('show').removeClass('hide')
            $(this).parent().addClass('searching')
        } else {
            $(this).siblings('.input-group-append').addClass('show').removeClass('hide')
            $(this).siblings('.search-btn').addClass('hide').removeClass('show')
            $(this).parent().removeClass('searching')
        }
    })

    if ($('.geoloc.hidden').length) {
        $.ajax({
            url: "https://geolocation-db.com/jsonp",
            jsonpCallback: "callback",
            dataType: "jsonp",
            success: function (location) {
                if(location.city) {
                    $('.city').text(location.city);
                    let citySlug = location.city.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
                    checkCity(citySlug);
                    $('.geoloc').removeClass('hidden')
                }else {
                    $('.city-container').addClass('hidden')
                    $('.geoloc').removeClass('hidden')
                }
            }
        });
    }

    function checkCity(citySlug) {
        let slug = 'all';
        $.ajax({
            url: "/checkCity",
            type: "GET",
            data: {
                'city': citySlug
            },
            success: function (data) {
                $('.top-slider form').attr('action','/'+data)
            },
            error: function () {
                $('.top-slider form').attr('action','/all')
            }
        });
        return slug;
    }

    let city = '';

    $('#getlocation').click(function (){
        navigator.geolocation.getCurrentPosition(success, error);
    })

    function success(position) {
        var GEOCODING = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + position.coords.latitude + '%2C' + position.coords.longitude + '&language=en&key=' + mapsApiKey;

        $.getJSON(GEOCODING).done(function(location) {
            city =  location.results[0].address_components[2].long_name
            $('.city').text(city);
            let citySlug = city.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
            checkCity(citySlug);
        })
    }

    function error(err) {
        console.log(err)
    }

    $('.cities-dropdown form.show-mobile input').on('keyup',function (){
        $('.cities-dropdown form.show-mobile + div').find('.dropdown-item:not(.hide-mobile)').addClass('hide-mobile')
        var text = $(this).val();

        var search = $('.cities-dropdown form.show-mobile + div').find('.dropdown-item a').filter( function ()
        {
            return $( this ).text().toLowerCase().indexOf( text.toLowerCase() ) >= 0;
        });

        $(search).parent().removeClass('hide-mobile')
    })

    $('.locations .view-more').click(function (){
        if($(this).find('> span').data('city') && $(this).find('> span').data('tag')) {
            window.location = '/'+$(this).find('> span').data('city')+'/restaurante/'+$(this).find('> span').data('tag');
            e.preventDefault()
        }
        $(this).siblings('.d-none').removeClass('d-none')
        $(this).addClass('d-none')
    })

    $('.index__popular .view-more').click(function (){
        $(this).parent().find('.d-none').removeClass('d-none')
        $(this).parent().find('.last-shown').removeClass('last-shown')
        $(this).addClass('d-none')
    })

    if ( Cookies.get('mobile-app-ads') === undefined ) {
        $('#mobile-app-ads').removeClass('d-none').addClass('d-flex');
    }
    $('#mobile-app-ads__close').click(function(){
        $('#mobile-app-ads').removeClass('d-flex').addClass('d-none');
        $('.main-header').css('top', '0px');
        $('body').css('margin-top', '0px');

        Cookies.set('mobile-app-ads', true, { expires: 7 });

        return false;
    });
});